import { render, staticRenderFns } from "./Buffering.vue?vue&type=template&id=45d8496e&scoped=true&lang=html&"
import script from "./Buffering.vue?vue&type=script&lang=js&"
export * from "./Buffering.vue?vue&type=script&lang=js&"
import style0 from "./Buffering.vue?vue&type=style&index=0&id=45d8496e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d8496e",
  null
  
)

export default component.exports